import React from 'react';
import './courses.css';
import udemyLogo from '../../assets/images/udemyLogo.png';
import courseraLogo from '../../assets/images/courseraLogo.png';
import udemyCertificate from '../../assets/images/udemyCertificate.jpg';

const Courses = () => {
    return (
        <section className='courses'>
            <div className='coursesTitleContainer'>
                <h2 className='coursesTitle'>Courses</h2>
            </div>
            <div className='courseContainer'>
                <div className='courseCard'>
                    <div className='courseDetails'>
                        <h3 className='courseName'>Object-Oriented Data Structures in C++</h3>
                        <h4 className='courseName'>Ordered and Unordered Data Structures</h4>
                        <p className='courseDescription'>These courses dive deep into implementing and optimizing data structures in C++. Projects included advanced applications of trees, hash maps, and linked lists, laying the foundation for complex algorithms.</p>
                    </div>
                    <img className='courseLogo' src={courseraLogo} alt='Coursera Logo' />
                </div>

                <div className='courseCard'>
                    <div className='courseDetails'>
                        <h3 className='courseName'>The Complete Neural Networks Bootcamp</h3>
                        <h4 className='courseTopic'>Theory and Applications of Neural Networks</h4>
                        <p className='courseDescription'>An extensive course covering neural network fundamentals, hands-on coding, and real-world applications like image recognition and NLP, providing a comprehensive understanding of deep learning.</p>
                    </div>
                    <img className='courseLogo' src={udemyLogo} alt='Udemy Logo' />
                </div>
            </div>
            <div className='courseCertificateContainer'>
                <img className='courseCertificate' src={udemyCertificate} alt='Certificate' />
            </div>
        </section>
    );
}

export default Courses;
